
import React, { Component , useState, useEffect  } from 'react';
import { connect } from 'react-redux';
import keys from '../../../keys';
import axios from 'axios'
import { fetchReports } from '../../../redux/reports/actions/actionCreators';
import { selectReport, updateReports } from '../../../redux/reports/actions/actions';
import { message, Row , Col, DatePicker , Select  } from 'antd';
import RowCard from '../components/RowCard';
import TopNavBar from '../components/TopNavBar';
import moment from 'moment'

const {Option} = Select

export const ReportFilter =(props)=> {

    const [filters , setFilters] = useState([])
    const [loaded , setLoaded] = useState(false)
    const [fetchingFilters , setFetchingFilters] = useState(false)

    const loadDropDownData = ()=> {   
        if(!loaded){
            axios.get(props.filter_url)
                .then(
                    response => {          
                        setFilters(response.data)
                        console.log(response.data)
                        setLoaded(true)
                        setFetchingFilters(false)               
                    }
                )
                .catch(
                    error => {
                        message.error("Loading failed!")
                        setFetchingFilters(false)     
                    }
                )
        }
    }

    useEffect(()=>{if(fetchingFilters){
        loadDropDownData()
    }},[fetchingFilters])
   

    return <Select  
                    placeholder="Select Category" 
                    value={props.value} 
                    loading = {fetchingFilters}
                    onDropdownVisibleChange={(isOpen)=> setFetchingFilters(isOpen)}
                    onChange={v=> props.onChange(props.title,v)}  
                    style={{width:"100%"}}>
                        {filters.map((option)=><Option key={option.id} value={option.id}>{option.title}</Option>)}
            </Select>
}


class Reports extends Component {
    constructor(props) {
        super(props);
        this.state = {
            from_date: new Date().toISOString().slice(0,10),
            to_date : new Date().toISOString().slice(0,10)
          }
    }

    componentDidMount(){
        this.props.fetchReports(
            ()=>{
                
                message.destroy()
                message.success("Loading successful!")
            }
            ,
            ()=>{
                message.error("Loading reports failed!")
            }
        )
    }

    navigate = (link) =>{
        this.props.history.push(link) 
    }

    onReportFilterChange = (title,value)=>{
        const reports = this.props.reports.reports.map(
            report => {
                if (title === report.title){ return {...report , value:value} } else {return report}
            }
        )
        this.props.updateReports(reports)
        console.log(title,value)
    }

    onDateRangeChange = (dates,dateStrings) => {
        this.setState({
            from_date : dateStrings[0],
            to_date : dateStrings[1]
        })

    }

    render() { 
        const {reports} = this.props.reports
        return ( 
        <>  
            <TopNavBar navigate={this.navigate} title={"Reports"}/> 
            <Row  style={{margin:20}}>
                <Col  span={8} > Date Range: <DatePicker.RangePicker value={[moment(this.state.from_date),moment(this.state.to_date)]}  onChange={this.onDateRangeChange}></DatePicker.RangePicker></Col>
            </Row>
            <Row style={{margin:20}} gutter={20}>
            {   reports.map(report => <Col span={8}>< RowCard 
                                            title={report.title} 
                                            onClick = {
                                                    ()=> {
                                                        this.props.selectReport(report)
                                                        const path = report.link+"?"+report.filter_param+"="+report.value 
                                                        + `&from_date=${this.state.from_date}&to_date=${this.state.to_date}`
                                                        this.navigate(path)
                                                    }}
                                            filter = {
                                                ()=><ReportFilter 
                                                        title = {report.title}
                                                        options={report.filters}
                                                        onChange = {this.onReportFilterChange}
                                                        value = {report.value}
                                                        filter_url= { keys.server + report.filter_url}                                                                   
                                                    />
                                            }
                                            />
                                            </Col>
                )       
                                }    
            </Row>
        </> 
        );
    }
}

const mapStateToProps = state => ({
    // categories : state.product.categories,
    reports : state.reports
})




const mapDispatchToProps = dispatch => ({
    fetchReports : (sc , ec) => dispatch(fetchReports(sc,ec)),
    updateReports : (reports) => dispatch(updateReports(reports)),
    selectReport : report => dispatch(selectReport(report))
})
 
export default connect(mapStateToProps,mapDispatchToProps)(Reports);